import badgesJson from '@content/badges.json'
import challengesJson from '@content/challenges.json'
import foodsJson from '@content/foods.json'
import habitsJson from '@content/habits.json'
import o1 from '@content/lessons/o1-parmak.json'
import o2 from '@content/lessons/o2-solunum.json'
import o3 from '@content/lessons/o3-dil.json'
import p1 from '@content/lessons/p1-firca.json'
import p2 from '@content/lessons/p2-beslenme.json'
import p3 from '@content/lessons/p3-kalici.json'
import recapJson from '@content/recap.json'
import shopJson from '@content/shop.json'
import {
  BadgesSchema,
  ChallengesSchema,
  catalogFromContent,
  FoodsSchema,
  HabitsSchema,
  type Lesson,
  LessonSchema,
  RecapSchema,
  ShopSchema,
} from '@disdis/shared'

/**
 * content/ is data, not code (ARCHITECTURE §1). It is parsed once here with the shared schemas
 * so a bad edit fails loudly at boot in dev and in `pnpm content:check` in CI, never silently.
 */

export const lessons: Lesson[] = [p1, p2, p3, o1, o2, o3].map((raw) => LessonSchema.parse(raw))
export const lessonById = new Map(lessons.map((lesson) => [lesson.id, lesson]))

export const foods = FoodsSchema.parse(foodsJson)
export const habits = HabitsSchema.parse(habitsJson)
export const badges = BadgesSchema.parse(badgesJson)
export const shop = ShopSchema.parse(shopJson)
/** W3-OVERHAUL §4: the Hatırlatma Eğitimi and the Günlük Görevler templates. */
export const recap = RecapSchema.parse(recapJson)
export const challenges = ChallengesSchema.parse(challengesJson)

/** The fold needs item prices and the chest cosmetics; both come from content. */
export const catalog = catalogFromContent(shop, lessons)
